import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import useFormName from '../../../../Hooks/useFormName';
import ErrorMessage from '../../../../Components/Form/components/ErrorMessage';
import TopFieldContent from '../../../../Components/Form/components/TopFieldContent';
import DosageInput from './DosageInput';

interface PhoneNumberFieldProps {
	name: string;
	label?: string;
	isRequired?: boolean;
	className?: string;
	onChange?: (value: string) => void;
}

const DosageField: React.FC<PhoneNumberFieldProps> = ({
	name,
	label,
	className,
	isRequired,
}) => {
	const { fieldName } = useFormName({ name });
	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
	});

	return (
		<div className={className}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<DosageInput {...field} />
			{error?.message && <ErrorMessage tx={error.message} />}
		</div>
	);
};

export default DosageField;
